
import { defineComponent, ref, onMounted } from "vue";
import { api } from "@/services/Api";
import swal from "sweetalert2";
import { useI18n } from "vue-i18n";
import q from "q";
import useOrder from "@/modules/useOrder";
import { isElectron } from '@/utils/electron'
import { printPdf } from "@/utils/printer";
import { useStore } from "@/store";
import { PrintSize } from "@/models/Enums";

export default defineComponent({
  props: {
    orderId: {
      required: true,
      type: Number,
    },
    orderNumber: {
      required: true,
      type: Number,
    },
    jobId: {
      type: Number,
      default: 0,
    },
  },
  async setup(props) {
    const { t } = useI18n();
    const { printTicket, printReceipt } = useOrder();
    const receiptPdfUrl = ref("");
    const store = useStore();
    function goHome() {
      window.location.reload();
    }
    async function printTicketAction() {

      printTicket(props.orderId, store.getters.printerSettings?.ticketPrinterSize ?? PrintSize.Check_8cm);
    }
    async function print() {
      await q.delay(200);
      swal.showLoading();
      const responsePromise = api.GetOrderTicketPdfUrl(props.orderId);
      await q.delay(400);
      const response = await responsePromise;
      if (response.errorMessage) {
        swal.fire({
          icon: "error",
          title: t("error-pop-up.oops"),
          text: t(`${response.errorMessage}`),
          confirmButtonText: t("cashier.label.ok"),
        });
        return;
      }
      swal.close();
      if (!isElectron()) {
        printPdf(response.data?.ticketPdfUrl ?? '');
      }
    }

    async function printReceiptClick() {
      const printReceiptPdfUrl = await printReceipt(
        props.jobId,
        receiptPdfUrl.value
      );
      if (printReceiptPdfUrl) {
        receiptPdfUrl.value = printReceiptPdfUrl;
      }
      swal.close();
    }
    const onMountedCall = async () => {
      const result = await swal.fire({
        text: t("cashier.alert.print-tickets"),
        icon: "info",
        showCancelButton: true,
        cancelButtonText: t("cashier.label.no"),
        confirmButtonText: t("cashier.label.yes"),
        customClass: {
          confirmButton: "popup-bookit-button",
          cancelButton: "close-button-wrapper popup-bookit-button",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        print();
      }
    };
    onMounted(onMountedCall);
    return { print, goHome, printTicketAction, printReceiptClick, receiptPdfUrl };
  },
});
